export const environment = {
  name: "dev",
  production: false,
  instrumentationKey: "",
  baseUrl: "https://ndaass-dev.azure.chevron.com",
  apiUrl: "https://ndaass-api-dev.azure.chevron.com",
  outboundApiUrl: "",
};